import { render, staticRenderFns } from "./BrandMultiSelect.vue?vue&type=template&id=08e924e4&scoped=true&"
import script from "./BrandMultiSelect.vue?vue&type=script&lang=js&"
export * from "./BrandMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BrandMultiSelect.vue?vue&type=style&index=1&id=08e924e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e924e4",
  null
  
)

export default component.exports